import { createStyles, makeStyles } from "@material-ui/core";

export const userStyles = makeStyles(() =>
  createStyles({
    body: {
      backgroundColor: "#fff",
      borderRadius: 14,
      marginTop: 20,
      width: "100%",
    },
    bodyTitle: {
      color: "#1a224b",
      fontFamily: "Montserrat",
      fontSize: 24,
      fontWeight: "bold",
      margin: "18px 471px 40px 15px",
    },
    cancelButtonModal: {
      backgroundColor: "red",
      color: "white",
    },
    filterStyle: {
      display: "flex",
      padding: "15px",
      alignItems: "center",
    },
    filterButton: {
      marginLeft: 10
    },
    footerStyleModal: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      justifyItems: "end",
    },
    header: {
      backgroundColor: "#fff",
      borderRadius: 14,
      margin: "10px 29px 24px 0",
      padding: "6px 10px 3px 11px",
      justifyContent: "center",
      width: "100%",
      alignItems: "center",
    },
    headerIcon: {
      textAlign: "right",
    },
    searchText: {
      marginLeft: "auto",
      width: 259,
    },
    tag: {
      fontFamily: "Montserrat",
      fontSize: 24,
      fontWeight: 300,
      lineHeight: 2.08,
      color: "#757a93",
    },
    table: {
      marginTop: 22,
      width: "100%",
    },
    textDeleteModal: {
      textAlign: "center",
    }
  })
);

